import React from "react";
import { useRequestService } from "./../_shared/request-service-provider/request-service-provider.js";
import { useWixInstanceService } from "./../_shared/request-service-provider/wix-instance-context.js";
import { useEditorProps } from "./../_shared/some-editor-props-context.js";
import { fetchMediaToken } from "./fetch-media-token.js";
const ImagePluginContext = React.createContext(null);
const ImagePluginContextProvider = ({ children }) => {
  const [cachedSettings, setCachedSettings] = React.useState(null);
  const wixInstance = useWixInstanceService();
  const { makeRequest } = useRequestService();
  const editorProps = useEditorProps();
  const getImageEditorSettings = React.useCallback(async () => {
    if (cachedSettings) {
      return cachedSettings;
    }
    const { metaSiteId } = wixInstance();
    if (!metaSiteId) {
      return null;
    }
    const token = await fetchMediaToken(makeRequest);
    const settings = token ? {
      initiator: editorProps.biSettings?.consumer || "ricos-default",
      siteToken: token,
      metaSiteId,
      mediaRoot: "photos"
    } : null;
    if (settings) {
      setCachedSettings(settings);
    }
    return settings;
  }, [cachedSettings, wixInstance]);
  return /* @__PURE__ */ React.createElement(
    ImagePluginContext.Provider,
    {
      value: React.useMemo(() => ({ getImageEditorSettings }), [getImageEditorSettings])
    },
    children
  );
};
export {
  ImagePluginContext,
  ImagePluginContextProvider
};
//# sourceMappingURL=context.js.map
